import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "./assets/css/style-page-modal.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ServerSignupKo() {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className="pageregistration">
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />

            {/* {isLoading && (
                <div
                    style={{
                        padding: "40px",
                        fontSize: "18px",
                        color: "#555",
                        height: "200px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="spinner-border text-primary" role="status"></div>
                    <div>처리 중...</div>
                </div>
            )} */}

            {/* Modal */}
            <iframe
                id="autoResizeIframe"
                src="https://hanbiro.vn/pages/ko/server-hosting-signup"
                style={{ width: "100%", border: "none", height: "90vh" }}
                loading="eager"
                title="Server Signup"
                onLoad={() => setIsLoading(false)}
            />

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default ServerSignupKo;
